// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimsTeamContactDto
 */
export interface IClaimsTeamContactDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimsTeamContactDto
     */
    contact_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamContactDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamContactDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamContactDto
     */
    role_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamContactDto
     * @deprecated
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimsTeamContactDto
     */
    role_id?: number;
}

/**
 * Check if a given object implements the IClaimsTeamContactDto interface.
 */
export function instanceOfIClaimsTeamContactDto(value: object): value is IClaimsTeamContactDto {
    return true;
}

export function IClaimsTeamContactDtoFromJSON(json: any): IClaimsTeamContactDto {
    return IClaimsTeamContactDtoFromJSONTyped(json, false);
}

export function IClaimsTeamContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsTeamContactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'role_name': json['role_name'] == null ? undefined : json['role_name'],
        'role': json['role'] == null ? undefined : json['role'],
        'role_id': json['role_id'] == null ? undefined : json['role_id'],
    };
}

export function IClaimsTeamContactDtoToJSON(json: any): IClaimsTeamContactDto {
    return IClaimsTeamContactDtoToJSONTyped(json, false);
}

export function IClaimsTeamContactDtoToJSONTyped(value?: IClaimsTeamContactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_id': value['contact_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'role_name': value['role_name'],
        'role': value['role'],
        'role_id': value['role_id'],
    };
}

